<template>
  <div>
    <div v-show="!ShowVerification" class="wide-wrapper register">
      <div class="row">
        <div class="col-12">
          <h1 class="page-title">Create an account</h1>
          <p class="body">
            Enter your details below to register and start using the CPSU's sports safeguarding tools.<br /><br />
            Fields marked with a <span class="asterisk"></span> are required
          </p>
          
          <tabs
            ref="tabs"
            :options="{ defaultTabHash: 'first-tab' }"
          >
            <tab id="first-tab" name="<span>Your account</span>" >
              <RegisterStep1 @clicked="setSelectedTab"></RegisterStep1>
            </tab>
            <tab id="second-tab" name="<span>Organisation details</span>" >
              <RegisterStep2
                @clicked="setSelectedTab"
                @setVerification="verificationHandler"
                
              ></RegisterStep2>
            </tab>
          </tabs>
        </div>
        <div class="space"></div>
      </div>
    </div>

    <div class="inner-wrapper" v-show="this.ShowVerification">
      <div class="inner-wrapper-md">
        <div class="row">
          <div class="col-12">
            <h4 class="page-title">Verify your account</h4>
            <div class="html-content" v-if="this.content && this.content.EmailVerificationNotificationPage" v-html="this.content.EmailVerificationNotificationPage"></div>
            <p v-else class="body" >
              We have sent you a link to verify your email. Please click the
              link in the email we just sent you to finish the set up of your
              account. If it doesn’t show, please check your spam/junk folder.
            </p>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegisterStep1 from "../components/register-step1";
import RegisterStep2 from "../components/register-step2";
import { mapActions,mapState } from "vuex";

export default {
  name: "Register",
  components: {
    RegisterStep1,
    RegisterStep2
  },
  data() {
    return {
      //isActive: false,
      ShowVerification: false
    };
  },
 async created(){
  this.resetUser();
   await this.getContent();
},
  methods: {
    ...mapActions("users", ["resetUser"]),
    ...mapActions("util", ["getContent"]),
    
    
    setSelectedTab(index) {
      this.$refs.tabs.selectTab(this.$refs.tabs.$children[index].hash);
      window.scrollTo(0, 0);
    },
    verificationHandler(value) {
       window.scrollTo(0,0);
      this.ShowVerification = value;
      
    }
  },
  computed: {
    ...mapState("util", ["content"]),
    href() {
      return "#" + this.name.toLowerCase().replace(/ /g, "-");
    }
  },
  mounted() {
//    this.isActive = this.selected;
  }
};
</script>

<style lang="scss"></style>
